import { render, staticRenderFns } from "./detailTable13.vue?vue&type=template&id=d6aa2c38&scoped=true&"
import script from "./detailTable13.vue?vue&type=script&lang=js&"
export * from "./detailTable13.vue?vue&type=script&lang=js&"
import style0 from "./detailTable13.vue?vue&type=style&index=0&id=d6aa2c38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6aa2c38",
  null
  
)

export default component.exports